import { render, staticRenderFns } from "./BrochureCard.vue?vue&type=template&id=0d443f45&scoped=true"
import script from "./BrochureCard.vue?vue&type=script&lang=js"
export * from "./BrochureCard.vue?vue&type=script&lang=js"
import style0 from "./BrochureCard.vue?vue&type=style&index=0&id=0d443f45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d443f45",
  null
  
)

export default component.exports